import { Component } from "vue-property-decorator";
import {
  ILoginProps,
  Login as ReactLogin,
} from "@graphapi-io/customer-components";
import { reactProxyFactory } from "@/components/shared/ReactProxy.component";
import { FunctionComponent } from "react";
import { UserModule } from "@/store/modules/user";
import LangControls from "@/mixins/LangControls.mixin";
import FooterLinks from "@/mixins/FooterLinks.mixin";
import { mixins } from "vue-class-component";

const Login = reactProxyFactory<FunctionComponent<ILoginProps>, ILoginProps>(
  ReactLogin as FunctionComponent<ILoginProps>,
);

@Component({})
export default class LoginView extends mixins(LangControls, FooterLinks) {
  private async onLogin(credentials: { username: string; password: string }) {
    await this.$authManager.login(credentials);
    if (!UserModule.isAuthenticated) {
      throw new Error(this.$t("login_error_wrong_credentials").toString());
    }
  }

  private onSignupClick() {
    this.$router.push("/signup");
  }

  private onForgotPasswordClick() {
    this.$router.push("/password-reset");
  }

  private get copies() {
    return {
      login: {
        signUp: this.$t("login.signUp").toString(),
        title: this.$t("login.title").toString(),
        subtitle: this.$t("login.subtitle").toString(),
        emailLabel: this.$t("login.emailLabel").toString(),
        emailPlaceholder: this.$t("login.emailPlaceholder").toString(),
        passwordLabel: this.$t("login.passwordLabel").toString(),
        passwordPlaceholder: this.$t("login.passwordPlaceholder").toString(),
        forgotPassword: this.$t("login.forgotPassword").toString(),
        login: this.$t("login.login").toString(),
        quote: this.$t("login.quote").toString(),
        quoteAuthor: this.$t("login.quoteAuthor").toString(),
      },
      authFooter: {
        imprintLink: this.$t("global_imprint").toString(),
        termsOfServiceLink: this.$t("global_terms").toString(),
        privacyPolicyLink: this.$t("global_privacy_policy").toString(),
      },
    };
  }

  render() {
    return (
      <Login
        componentProps={{
          onLogin: this.onLogin,
          onSignupClick: this.onSignupClick,
          onForgotPasswordClick: this.onForgotPasswordClick,
          copies: this.copies,
          imprintUrl: this.imprintUrl,
          termsOfServiceUrl: this.termsUrl,
          privacyPolicyUrl: this.privacyUrl,
          currentLang: this.currentLang,
          langOptions: this.langOptions,
          onLangChange: this.onLangChange,
        }}
      />
    );
  }
}
